import { render, staticRenderFns } from "./AprobarPedidoItems.vue?vue&type=template&id=7b5f6ac2&scoped=true&"
import script from "./AprobarPedidoItems.vue?vue&type=script&lang=js&"
export * from "./AprobarPedidoItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5f6ac2",
  null
  
)

export default component.exports